import React, { useEffect } from 'react';
import WellboreAddPhoto from '../images/WellboreAdd.png';
import WellboreAddPhoto2 from '../images/WellboreAdd2.png';
import WellboreEditPhoto from '../images/WellboreEdit.png';
import WellboreRemoveOnePhoto from '../images/WellboreRemoveOne.png';
import WellboreRemoveAllPhoto from '../images/WellboreRemoveAll.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const WellborePage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Wellbore
        </div>
        <div style={{ margin: '10px 0px' }}>
        To add a wellbore, right click <strong>Project</strong> node, then click <strong>Add Wellbore</strong> menu. In <strong>Add Wellbore</strong> dialog, 
        enter wellbore name, latidtude, longitude, elevation, radius, joint points and select a color, then click <strong>OK</strong>.
        </div>
        <div style={{ margin: '10px 0px' }}>
        Joint point's data format is East, North and Depth which is relative to the wellbore head. Each joint point is in a line. 
        The first line should be 0, 0, 0 which represents the wellbore head. The unit is meter or foot, you set it in <strong>Add Coordinate Origin</strong> dialog.
        </div>

        <StyledContainer>
            <img src={WellboreAddPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        After wellbore added, to add another wellbore, right click <strong>Project</strong> node, then click <strong>Add Wellbore</strong> menu, 
        or right click <strong>Wellbore Group</strong> node, then click <strong>Add Wellbore</strong> menu.
        </div>

        <StyledContainer>
            <img src={WellboreAddPhoto2} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To edit a wellbore, right click wellbore node you want to edit, then click <strong>Edit This Wellbore</strong> menu.
        </div>

        <StyledContainer>
            <img src={WellboreEditPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove a wellbore, right click wellbore node you want to remove, then click <strong>Remove This Wellbore</strong> menu.
        </div>
        <StyledContainer>
            <img src={WellboreRemoveOnePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove all of wellbores, right click <strong>Wellbore Group</strong> node, then click <strong>Remove All Wellbores</strong> menu.
        </div>
        <StyledContainer>
            <img src={WellboreRemoveAllPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default WellborePage;